module.exports = __webpack_public_path__ + "img/2.eff3b38c.png";